import React, { useContext } from 'react';
import { AngularServicesContext } from 'react-app';
import t from 'react-translate';

import { AiSuggestedComponentProps } from 'redux/schemas/models/ai-course-creation';
import { ComponentType, LectureComponent } from 'redux/schemas/models/lecture-component';

const FeedbackTitle = ({ activity }: { activity: LectureComponent<ComponentType.PUBLIC_PEER_EVALUATION> }) => {
  const { peerEvaluation } = activity;
  const { $state } = useContext(AngularServicesContext);

  if (peerEvaluation.requiredExercise?.id) {
    const stateParams = {
      id: peerEvaluation.requiredExercise.lecturePageId,
      lectureActivityId: peerEvaluation.requiredExercise.lectureComponentId,
    };

    return (
      <span>
        {t.LECTURE_PAGES.LHS.NOVO_AI.SUGGEST_ACTIVITIES.FEEDBACK_TITLE(
          $state.href('lecture-page', stateParams),
          peerEvaluation.requiredExercise.title,
        )}
      </span>
    );
  }

  return <span>{peerEvaluation.title}</span>;
};

const ActivityTitle = ({ componentSet }: AiSuggestedComponentProps) => {
  const { activity, secondaryActivities } = componentSet;

  const getActivityTitle = () => {
    switch (activity.type) {
      case ComponentType.PROFILE_COMPLETION:
        return activity.profileRequirement.title;
      case ComponentType.MEET_AND_GREET:
        return secondaryActivities[0].content;
      case ComponentType.POLL:
        return activity.poll.title;
      case ComponentType.EXERCISE:
        return activity.exercise.title;
      case ComponentType.PUBLIC_PEER_EVALUATION:
        return <FeedbackTitle activity={activity} />;
      case ComponentType.TOPIC:
        return activity.topic.title;
      case ComponentType.QUIZ:
        return activity.quiz.title;
      case ComponentType.SURVEY:
        return activity.survey.title;
      default:
        return null;
    }
  };

  return (<div className='text-lg-bold'>{getActivityTitle()}</div>);
};

export default ActivityTitle;
